import UnauthorizedComponent from 'components/403/unauthorized';
import authService, { AuthenticationAction } from 'core/services/auth';
import { ReactNode } from 'react';

interface CheckPermissionProps {
  modules: AuthenticationAction[];
  children: ReactNode;
}

export const CheckPermission = ({ modules, children }: CheckPermissionProps): JSX.Element => {
  // Check if user is main admin (has all permissions)
  if (authService.isMainAdmin) {
    return <>{children}</>;
  }

  // Check if user has at least one of the required permissions
  const hasPermission = modules.some(requiredModule => 
    authService.permissions.includes(requiredModule)
  );

  if (!hasPermission) {
    return <UnauthorizedComponent />;
  }

  return <>{children}</>;
};